import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_cross-white",
  "use": "icon_cross-white-usage",
  "viewBox": "0 0 22 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 21\" id=\"icon_cross-white\"><path d=\"M0 13.42h7.968V21h6.14v-7.58H22V7.58h-7.893V0H7.968v7.58H0v5.84z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol